<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "Pricing",

  metaInfo: { title: "Pricing" },

  extends: View,

  mixins: [
    LoadSections([
      "hero-alt6",
      // "theme-features2",
      //"features2",
      "contact-us",
      "service1",
      "service2",
      "info"
    ])
  ],

  props: {
    id: {
      type: String,
      default: "pricing"
    }
  }
};
</script>
